import { render, staticRenderFns } from "./cdek-delivery-point.vue?vue&type=template&id=cd0f5340&scoped=true"
import script from "./cdek-delivery-point.vue?vue&type=script&lang=js"
export * from "./cdek-delivery-point.vue?vue&type=script&lang=js"
import style0 from "./cdek-delivery-point.vue?vue&type=style&index=0&id=cd0f5340&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0f5340",
  null
  
)

export default component.exports